import React from "react";
import { Container, CssBaseline, Box, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { tokens } from "../theme";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        height: "100dvh",
        display: "grid",
        placeItems: "center",
        textAlign: "center",
      }}
    >
      <CssBaseline />
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <SearchOffIcon
          sx={{ fontSize: 64, color: colors.redAccent[400], mb: 1 }}
        />
        <Typography
          sx={{ fontSize: 96, fontWeight: 800, lineHeight: 1, color: colors.grey[100] }}
          component="h1"
        >
          404
        </Typography>
        <Typography sx={{ fontSize: 20, fontWeight: 600, mt: 2 }} gutterBottom>
          {t("notFound.title")}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: colors.grey[300], maxWidth: 320, mb: 3 }}
        >
          {t("notFound.subtitle")}
        </Typography>
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", justifyContent: "center" }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
          >
            {t("common.back")}
          </Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<HomeOutlinedIcon />}
            onClick={() => navigate("/dashboard")}
          >
            {t("notFound.goHome")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
